<header>
  <div class="wrap">
    <div class="text">
      <h2 class="title">{{ 'popins.fence-kit-angle-info.title' | translate }}</h2>
      <p class="mt-3 mb-4">{{ 'popins.fence-kit-angle-info.description' | translate }}</p>
    </div>
    <div class="header-actions">
      <button class="close" (click)="modalService.close()" title="{{ 'generic.close' | translate }}">
        <span class="icon-view-close" aria-hidden="true">
          <svg>
            <use xlink:href="assets/img/icons.svg#icon-view-close"></use>
          </svg>
        </span>
        <span>{{ 'generic.close' | translate }}</span>
      </button>
    </div>
  </div>
</header>
<div class="main container-fluid">
  <img class="rounded mx-auto d-block" src="assets/img/fence/kit-angle.png" alt="kit-angle" />

  <iframe
    src="https://www.youtube.com/embed/2epODUHmfDI"
    class="rounded mx-auto d-block mt-2"
    title="Comment installer un adaptateur de poteau d’angle Neva Castorama"
    frameborder="0"
    height="258"
    width="459"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    allowfullscreen></iframe>

  <footer class="popin-footer mt-3">
    <ng-casto-btn
      class="blue"
      [label]="'popins.fence-kit-angle-info.confirm' | translate"
      (click)="modalService.close()"></ng-casto-btn>
  </footer>
</div>
